import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import styled from "styled-components";
import { GlobalState } from "../../GlobalState";
import Loading from "../utils/loading";
import { editAccess } from "../utils/utils";
import { FaEdit, FaClock } from "react-icons/fa";

const Container = styled.div`
width: 70%;
  @media (max-width: 860px) {
    width: 90%;
  }
`;

const Card = styled.div`
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  border: 2px solid #e2e8f0;
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.5rem;
  margin-bottom: 1rem;
  border-bottom: 2px solid #f1f5f9;
`;

const SectionTitle = styled.h3`
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  background: linear-gradient(135deg, #107066 0%, #0b5a52 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const EditButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  background: ${(p) =>
    p.active
      ? "linear-gradient(135deg, #107066 0%, #0b5a52 100%)"
      : "rgba(16, 112, 102, 0.1)"};
  color: ${(p) => (p.active ? "white" : "#107066")};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: scale(1.1);
  }
`;

const SaveButton = styled.button`
  background: linear-gradient(135deg, #107066 0%, #0b5a52 100%);
  border: none;
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  margin-right: 10px;
  cursor: pointer;
`;

const CancelButton = styled.button`
  background: #e2e8f0;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
`;

const UnitInput = styled.input`
  width: 120px;
  padding: 6px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  text-align: right;
`;

const HPInput = styled.input`
  width: 70px;
  padding: 4px;
  text-align: center;
  border: ${(p) => (p.editable ? "2px solid #107066" : "1px solid #ccc")};
  border-radius: 6px;
`;

const TableWrapper = styled.div`
  overflow-x: auto;
  margin-top: 1rem;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th, td {
    padding: 8px;
    text-align: center;
  }

  th {
    background: #f9fafb;
    font-weight: 700;
  }

  td {
    border-bottom: 1px solid #e2e8f0;
  }
`;

export default function CombinedUnitPumpComponent({ loading, userData, orgId }) {
  const state = useContext(GlobalState);

  const [unitValue, setUnitValue] = useState("");
  const [editingUnit, setEditingUnit] = useState(false);
  const [lastModified, setLastModified] = useState("");
  const [unitError, setUnitError] = useState("");
  const [unitSuccess, setUnitSuccess] = useState("");
  const [unitOriginal, setUnitOriginal] = useState("");

  const [pumpData, setPumpData] = useState([]);
  const [updatedPumpData, setUpdatedPumpData] = useState([]);
  const [editingPumps, setEditingPumps] = useState(false);
  const [pumpLoading, setPumpLoading] = useState(true);
  const [pumpError, setPumpError] = useState("");
  const [pumpSuccess, setPumpSuccess] = useState("");

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const fetchUnitRate = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}/user/unitrate/${userData.org_id}`,
          { headers: { Authorization: state.token[0] } }
        );

        const val = parseFloat(res.data?.current_unit_rate);
        setUnitValue(!isNaN(val) ? val.toFixed(2) : "7.35");

        if (res.data.updatedAt) {
          const dt = new Date(res.data.updatedAt).toLocaleString();
          setLastModified(dt);
        }
      } catch {
        setUnitValue("7.35");
      }
    };

    if (userData?.org_id) fetchUnitRate();
  }, [userData, state.token]);

  useEffect(() => {
    const fetchPumpData = async () => {
      try {
        const token = state.token[0];
        const oid = orgId || userData?.org_id;

        const res = await axios.get(
          `${process.env.REACT_APP_API}/user/pumplist/${oid}`,
          { headers: { Authorization: token } }
        );

        // setPumpData(res.data);
        // setUpdatedPumpData(res.data);
        setPumpData(JSON.parse(JSON.stringify(res.data)));
        setUpdatedPumpData(JSON.parse(JSON.stringify(res.data)));

      } finally {
        setPumpLoading(false);
      }
    };

    fetchPumpData();
  }, [orgId, userData, state.token]);

  const handleUnitUpdate = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API}/user/unitrate/${userData.org_id}`,
        { newRate: parseFloat(unitValue) },
        { headers: { Authorization: state.token[0] } }
      );

      setUnitSuccess("Unit updated successfully");
      setEditingUnit(false);

      setTimeout(() => setUnitSuccess(""), 2000);
    } catch {
      setUnitError("Failed to update Unit");
    }
  };

  // const handleUnitCancel = () => {
  //   setEditingUnit(false);
  //   setUnitError("");
  //   setUnitSuccess("");
  // };
  const handleUnitCancel = () => {
    setUnitValue(unitOriginal);  // restore original value
    setEditingUnit(false);
    setUnitError("");
    setUnitSuccess("");
  };

  // const handleHPUpdate = async () => {
  //   try {
  //     const token = state.token[0];
  //     const oid = orgId || userData.org_id;

  //     const updates = [];

  //     updatedPumpData.forEach((section) => {
  //       section.sensors.forEach((item) => {
  //         updates.push({
  //           motor_id: item.motor_id,
  //           capacity_in_hp: item.capacity_hp
  //         });
  //       });
  //     });

  //     await axios.patch(
  //       `${process.env.REACT_APP_API}/user/update-hp`,
  //       { org_id: oid, updates },
  //       { headers: { Authorization: token } }
  //     );

  //     setPumpSuccess("HP updated successfully");
  //     setEditingPumps(false);

  //     setTimeout(() => setPumpSuccess(""), 2000);
  //   } catch {
  //     setPumpError("Failed to update HP");
  //   }
  // };

  const handleHPUpdate = async () => {
    try {
      const token = state.token[0];
      const oid = orgId || userData.org_id;

      const updates = [];

      updatedPumpData.forEach((section) => {
        section.sensors.forEach((item) => {
          updates.push({
            motor_id: item.motor_id,
            capacity_in_hp: item.capacity_hp
          });
        });
      });

      await axios.patch(
        `${process.env.REACT_APP_API}/user/update-hp`,
        { org_id: oid, updates },
        { headers: { Authorization: token } }
      );

      const refreshed = await axios.get(
        `${process.env.REACT_APP_API}/user/pumplist/${oid}`,
        { headers: { Authorization: token } }
      );

      setPumpData(JSON.parse(JSON.stringify(refreshed.data)));
      setUpdatedPumpData(JSON.parse(JSON.stringify(refreshed.data)));

      setPumpSuccess("HP updated successfully");
      setEditingPumps(false);

      setTimeout(() => setPumpSuccess(""), 2000);

    } catch {
      setPumpError("Failed to update HP");
    }
  };


  const handleHPCancel = () => {
    setUpdatedPumpData(JSON.parse(JSON.stringify(pumpData)));
    setEditingPumps(false);
    setPumpError("");
    setPumpSuccess("");
  };

  const hasAnyPumpOrBorewell =
    pumpData?.some(section => section.sensors && section.sensors.length > 0);

  if (!hasAnyPumpOrBorewell) {
    return (
      <Container>
        <Card>
          <SectionHeader>
            <SectionTitle>Unit Rate</SectionTitle>

            <EditButton
              active={editingUnit}
              onClick={() => {
                if (!editingUnit) {
                  setUnitOriginal(unitValue);
                }
                setEditingUnit(!editingUnit);
              }}
            >
              <FaEdit size={14} />
            </EditButton>
          </SectionHeader>

          {!editingUnit ? (
            <>
              <p>₹{unitValue}</p>

              {lastModified && (
                <div
                  style={{
                    fontSize: "0.8rem",
                    color: "#64748b",
                    marginTop: "8px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <FaClock size={12} /> {lastModified}
                </div>
              )}
            </>
          ) : (
            <>
              <UnitInput
                type="number"
                step="0.01"
                value={unitValue}
                onChange={(e) => setUnitValue(e.target.value)}
              />

              <div style={{ marginTop: "1rem" }}>
                <SaveButton onClick={handleUnitUpdate}>Save</SaveButton>
                <CancelButton onClick={handleUnitCancel}>Cancel</CancelButton>
              </div>
            </>
          )}

          {unitError && <p style={{ color: "red" }}>{unitError}</p>}
          {unitSuccess && <p style={{ color: "green" }}>{unitSuccess}</p>}
        </Card>
      </Container>
    );
  }

  return (
  <Container>
    <Card>
    
      <SectionHeader
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "0.75rem",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}>
          <SectionTitle style={{ margin: 0 }}>Unit Rate:</SectionTitle>

          {!editingUnit ? (
            <p style={{ margin: 0 }}>₹{unitValue}</p>
          ) : ( 
            <UnitInput
              type="number"
              step="0.01"
              value={unitValue}
              onChange={(e) => setUnitValue(e.target.value)}
            />
          )}

          {/* {!editingUnit && lastModified && (
            <div
              style={{
                fontSize: "0.8rem",
                color: "#64748b",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <FaClock size={12} /> {lastModified}
            </div>
          )} */}
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          {editingUnit && (
            <>
              <SaveButton onClick={handleUnitUpdate}>Save</SaveButton>
              <CancelButton onClick={handleUnitCancel}>Cancel</CancelButton>
            </>
          )}

          <EditButton
            active={editingUnit}
            onClick={() => {
              if (!editingUnit) {
                setUnitOriginal(unitValue);
              }
              setEditingUnit(!editingUnit);
            }}
          >
            <FaEdit size={14} />
          </EditButton>
        </div>
      </SectionHeader>

      {unitError && <p style={{ color: "red" }}>{unitError}</p>}
      {unitSuccess && <p style={{ color: "green" }}>{unitSuccess}</p>}

      <hr style={{ margin: "1.5rem 0" }} />

      <SectionHeader>
        <SectionTitle>Pumps & Borewells</SectionTitle>

        <EditButton
          active={editingPumps}
          onClick={() => {
            if (!editingPumps) {
              setUpdatedPumpData(JSON.parse(JSON.stringify(pumpData)));
            }
            setEditingPumps(!editingPumps);
          }}
        >
          <FaEdit size={14} />
        </EditButton>
      </SectionHeader>

      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          cursor: "pointer",
          fontWeight: 600,
          marginBottom: "0.5rem",
        }}
      >
        {isOpen ? "▲ Hide" : "▼ Show"}
      </div>

      {isOpen && (
        <>
          <TableWrapper>
            <StyledTable>
              <thead>
                <tr>
                  <th style={{ textAlign: "left" }}>Location</th>
                  <th>HP</th>
                </tr>
              </thead>
              <tbody>
                {updatedPumpData.map((sec, s) =>
                  sec.sensors.map((item, i) => (
                    <tr key={`${s}-${i}`}>
                      <td style={{ textAlign: "left" }}>{item.location_name}</td>
                      <td>
                        <HPInput
                          type="number"
                          editable={editingPumps}
                          readOnly={!editingPumps}
                          value={item.capacity_hp}
                          onChange={(e) => {
                            const newData = JSON.parse(JSON.stringify(updatedPumpData));
                            newData[s].sensors[i].capacity_hp = e.target.value;
                            setUpdatedPumpData(newData);
                          }}
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </StyledTable>
          </TableWrapper>

          {editingPumps && (
            <div
              style={{
                marginTop: "1rem",
                display: "flex",
                justifyContent: "center",
                gap: "0.7rem",
              }}
            >
              <SaveButton onClick={handleHPUpdate}>Save</SaveButton>
              <CancelButton onClick={handleHPCancel}>Cancel</CancelButton>
            </div>
          )}

          {pumpError && <p style={{ color: "red" }}>{pumpError}</p>}
          {pumpSuccess && <p style={{ color: "green" }}>{pumpSuccess}</p>}
        </>
      )}
    </Card>
  </Container>
);
}
